import { State } from '@/store/store'
export interface IRoleList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  data: Array<{
    _id?: string;
    name?: string;
  }>
}

export interface IRole {
  _id: string
  role: string
  name?: string
  requireCenter?: boolean
  createdAt?: number
}

export interface IPermission {
  _id: string
  permission: string
  createdAt?: number
}

export interface RolePermissionList {
  _id: string,
  permissionId: string,
  roleId: string,
  type: string[]
}

export class RoleState {
  public list: IRoleList
  public rolePermissionList: RolePermissionList[]
  public roleUserList: any
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      data: [],
      defaultFilter: {},
    }
    this.rolePermissionList = []
  }
}

export default RoleState
